import { Component, ViewChild, OnInit } from '@angular/core';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { Globals } from 'app/_globals';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { NotificationService } from 'app/_services/notification.service';
import { environment } from '../../../environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { OrdersService } from 'app/_services/orders.service';
import { OpayoService } from 'app/_services/opayo.service';
import { CustomersService } from 'app/_services/customer.service';
import { Transaction, RefundRequest, Refund } from 'app/_interfaces/opayo.interface';

@Component({
  selector: 'app-indi-order',
  templateUrl: './indi-order.component.html',
  styleUrls: ['./indi-order.component.css'],
})
export class IndiOrderComponent implements OnInit {
  selectedOrder: any;
  selectedOrderID: any;
  storeId: any;
  tabitems: any = [];

  cookieStore: any;
  role: any;
  routeRole: any;

  purchaseCustomer: any;
  charge: any;

  refundModal = false;
  refundForm: FormGroup;

  opayoModal = false;

  opayoTransaction: Transaction;

  availableRefund = 0;

  constructor(
    public loader: LoadingBarService,
    public activatedRoute: ActivatedRoute,
    public router: Router,
    public globals: Globals,
    public fb: FormBuilder,
    public notificationService: NotificationService,
    public cookieService: CookieService,
    public _ordersService: OrdersService,
    public _customerService: CustomersService,
    private _opayoService: OpayoService
  ) {
    // Get Order id from params
    this.activatedRoute.params.subscribe((params: Params) => {
      this.selectedOrderID = params.id;
    });

    // Handle Store Cookies
    const hasCurrentStore = cookieService.check('currentStore');
    if (hasCurrentStore) {
      this.cookieStore = JSON.parse(cookieService.get('currentStore'));
      this.storeId = this.cookieStore.id;
    } else {
      this.router.navigate(['/' + this.globals.user.routeRole + '/select-store']);
    }

    this.role = globals.user.role;
    this.routeRole = globals.user.routeRole;

    this.refundForm = fb.group({
      amount: new FormControl(this.availableRefund, [Validators.required]),
      notes: new FormControl('', [Validators.required]),
    });

    this.tabitems = [{ path: '/' + this.routeRole + '/orders/', title: 'Orders', class: 'back-link' }];
  }

  ngOnInit() {
    this.getSelectedOrder(this.selectedOrderID);
  }

  // Get Selected Order
  public getSelectedOrder(id) {
    this._ordersService.getOrderById(id).subscribe((data: any) => {
      // console.log('Order Data - ', data);

      for (let i = 0; i < data.purchaseItems.length; i++) {
        const groups = {};

        data.purchaseItems[i].purchaseItemComponents.forEach(function (item) {
          const list = groups[item.grouping];

          if (list) {
            list.push(item);
          } else {
            groups[item.grouping] = [item];
          }
        });

        if (data.purchaseItems[i].purchaseItemComponents.length) {
          data.purchaseItems[i].groupedItems = groups;
        }
      }

      this.selectedOrder = data;

      if (this.selectedOrder.charge && this.selectedOrder.charge.paymentProvider && this.selectedOrder.charge.paymentProvider.value === 'OPAYO') {
        this.getOpayoTransaction(this.selectedOrder.charge.transactionId);
      }

      this.getCustomerByOrder(data.id);
    });
  }

  getOpayoTransaction(transactionId) {
    this._opayoService.getTransaction(transactionId).subscribe(
      (data: any) => {
        if (data && data.Transaction) {
          this.opayoTransaction = data.Transaction;
          this.availableRefund = this.selectedOrder.totalPrice;

          if (data.Transaction.Refunds && data.Transaction.Refunds.length) {
            for (let i = 0; i < data.Transaction.Refunds.length; i++) {
              const refund = data.Transaction.Refunds[i];
              this.availableRefund = this.availableRefund - refund.RefundAmount;
            }
          }

          this.refundForm.patchValue({
            amount: this.availableRefund,
            notes: '',
          });
        }
      },
      (error) => {
        console.log('transaction error - ', error);
      }
    );
  }

  // Get Customer by Order
  public getCustomerByOrder(id) {
    this._customerService.getCustomerByPurchase(id).subscribe((data: any) => {
      // console.log('Customer data - ', data);
      this.purchaseCustomer = data;
    });
  }

  public toggleRefundModal() {
    this.refundModal = !this.refundModal;
  }

  public toggleOpayoModal() {
    this.opayoModal = !this.opayoModal;
  }

  public onRefundFormSubmit() {
    const values = this.refundForm.value;

    const body = {
      TransactionId: this.selectedOrder.charge.transactionId,
      Amount: values.amount,
      Notes: values.notes,
    };

    this.toggleRefundModal();

    this._opayoService.refundTransaction(body).subscribe((data: any) => {
      this.getOpayoTransaction(this.selectedOrder.charge.transactionId);

      this.notificationService.notify('success', 'Refund Applied', 'Refund was sucessfully applied', 'top', 'right');
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/orders/indi-order/indi-order.component.ts